import { useState } from "react";
import { Box, Button, Card, CardContent, Stack, TextField, Typography } from "@mui/material";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../router/constants";
import { requestPasswordReset } from "../../services/passwordReset.service";

export function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await requestPasswordReset(email);
      toast.success("Se existir uma conta ativa com esse e-mail, enviaremos um link de recuperação.");
      navigate(ROUTES.SIGNIN);
    } catch (e: any) {
      const msg = e?.response?.data?.message || e?.message;
      toast.error(msg ? String(msg) : "Falha ao solicitar recuperação");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ width: "100vw", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", p: 2 }}>
      <Card sx={{ width: "100%", maxWidth: 520 }}>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h6" fontWeight={700} color="#133859">
              Recuperar senha
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Informe seu e-mail. Se existir uma conta ativa, enviaremos um link para redefinir sua senha.
            </Typography>
            <TextField
              label="E-mail"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
            />
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1} justifyContent="flex-end">
              <Button variant="text" color="inherit" onClick={() => navigate(ROUTES.SIGNIN)} disabled={loading}>
                Voltar
              </Button>
              <Button variant="contained" onClick={handleSubmit} disabled={loading || !email}>
                {loading ? "Enviando..." : "Enviar"}
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
